import { render, staticRenderFns } from "./About1.vue?vue&type=template&id=013e0afc&scoped=true&"
import script from "./About1.vue?vue&type=script&lang=js&"
export * from "./About1.vue?vue&type=script&lang=js&"
import style0 from "./About1.vue?vue&type=style&index=0&id=013e0afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013e0afc",
  null
  
)

export default component.exports